import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { tagsApi, messagesApi } from '../lib/api';

// Badge: tag speciale (kind='badge') con pallino colorato e cartella IMAP.
export interface Badge {
  id: string;
  name: string;
  color: string;
  icon: string | null;
  kind: 'badge';
}

// Elenco badge disponibili (garantisce i predefiniti Alert/Da rispondere).
export function useBadges() {
  return useQuery({
    queryKey: ['badges'],
    staleTime: 0,
    refetchOnMount: 'always',
    queryFn: async () => {
      const res = await tagsApi.badges();
      return (res?.badges ?? res ?? []) as Badge[];
    },
  });
}

// Invalida le query che mostrano badge/tag sui messaggi dopo add/remove.
function invalidateBadgeRelated(qc: ReturnType<typeof useQueryClient>) {
  qc.invalidateQueries({ queryKey: ['message'] });
  qc.invalidateQueries({ queryKey: ['feed'] });
  qc.invalidateQueries({ queryKey: ['messages'] });
  qc.invalidateQueries({ queryKey: ['badges'] });
  qc.invalidateQueries({ queryKey: ['tags'] });
}

// Assegna un badge a un messaggio (esistente {badgeId} o nuovo {name,color}).
export function useAddMessageBadge() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      messageId,
      badge,
    }: {
      messageId: string;
      badge: { badgeId: string } | { name: string; color?: string };
    }) => messagesApi.addBadge(messageId, badge),
    onSuccess: () => invalidateBadgeRelated(qc),
  });
}

// Rimuove un badge da un messaggio (elimina anche la copia IMAP).
export function useRemoveMessageBadge() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ messageId, badgeId }: { messageId: string; badgeId: string }) =>
      messagesApi.removeBadge(messageId, badgeId),
    onSuccess: () => invalidateBadgeRelated(qc),
  });
}
